import React from 'react';
import { Box } from '@mui/material';
import { AU, BORDE_AZUL } from '../../styles/tokensAU';
import EtiquetaAU from './EtiquetaAU';

// "PASO 1 DE 2" y un segmento por paso (el actual y los anteriores en azul). Los segmentos son solo
// decoración: el texto visible ya dice en qué paso va, así que no se anuncian dos veces.
const BarraDePasos = ({ paso, total = 2 }) => (
  <Box>
    <EtiquetaAU component="p" sx={{ m: 0, mb: 1 }}>{`Paso ${paso} de ${total}`}</EtiquetaAU>
    <Box sx={{ display: 'flex', gap: 1 }}>
      {Array.from({ length: total }, (_, i) => (
        <Box
          key={i}
          data-segmento
          aria-hidden="true"
          sx={{ flex: 1, height: 4, borderRadius: '2px', bgcolor: i + 1 <= paso ? AU.azul : BORDE_AZUL }}
        />
      ))}
    </Box>
  </Box>
);

export default BarraDePasos;
